// @ts-nocheck
import React, { createRef } from "react";
import NormalSpin from "../../../base/basicComponents/spin";
import ApproveShareService from "../../../service/shareTask/approveShareService";
import { dataStatus, actions } from "../../publicDictionaryValues";
import reasonEditDefaultIcon from "../../../assets/image/reasonEditIcon.png";
import styles from "../procedureFileProcess/style/index.module.scss";
import ShareProcessBase from "../../commonComponents/shareProcessBase";
import ReviseShareTaskProcess from "./reviseShareTask";
import ApproveShareTaskProcess from "./approveShareTask";
import ReviseShareTaskComplete from "./reviseShareTaskComplete";
import ApproveShareTaskComplete from "./approveShareTaskComplete";
import SubmitShareTaskComplete from "./submitShareTaskComplete";
import CompleteStepBusinessType from "../../../service/stepBase/completeStepBusinessType";
import StepService from "../../../service/stepBase/StepService";

const procedureReplaceFileRef = createRef();
const procedureRef = createRef();
const procedureServerPathRef = createRef();
const procedureSavedInRef = createRef();
const approvePageRef = createRef();

export default class ManageShareTaskProcess extends ShareProcessBase {
  constructor(props: any) {
    super(props);
    this.setGlobalVariables();
    this.initManageShareTaskProcedureFileState();
    // @ts-ignore
    this.procedureFileStepID = null;
    // @ts-ignore
    this.savedInReturnReasonLog = [];
    // @ts-ignore
    this.serverPathReturnReasonLog = [];
    // @ts-ignore
    this.initProcedureTableData = [];
  }

  handleManageShareTaskPageState = () => {
    return {
      requestByID: null,
      requestByName: null,
      receiveDate: null,
      procedureID: null,
      procedureStepID: null,
      procedureStatus: null,
      isSaveDisabled: false,
      isCancelDisabled: false,
      isSubmitDisabled: false,
      isRejectDisabled: false,
      procedureFolder: {},
      rejectReason: null,
      rejectStatus: null,
      currentRole: null,
      actionName: null,
      loading: false,
      procedureStepStatus: null,
      uploadProcedureFileNum: 0,
      procedureFileNum: 0,
      procedureNote: "",
    };
  };

  initManageShareTaskProcedureFileState = () => {
    this.state = {
      pageState: this.handleManageShareTaskPageState(),
      initTableDate: {},
      // @ts-ignore
      savedInSectionState: this.initSavedInSectionState,
      // @ts-ignore
      serverPathSectionState: this.initServerPathSectionState,
      // @ts-ignore
      procedureFileTableState: this.initProcedureFileTableState,
      isReturnReasonLogOpen: false,
      fileTableData: [],
      supportingTableData: [],
      taskInfoData: {},
      procedureInfoData: {},
      procedureFileData: {},
      shareTaskData: {},
      ppoList: [],
      jbProcedureSavedIn: null,
    };
  };

  handleManageShareTaskSavedInSectionState = (result: any) => {
    return {
      ...this.state.savedInSectionState,
      savedInReturnReasonInputValue:
        result.procedureFolder?.procedureSaveInCategoryReturnReason || null,
      savedInRadioValue: result.procedureFolder?.procedureSaveInCategoryID || null,
      isSavedInReturned:
        result.procedureFolder?.procedureSaveInCategoryStatusID === dataStatus.return,
      procedureSaveInCategoryStatusID:
        result.procedureFolder?.procedureSaveInCategoryStatusID || null,
      isSavedInApproveBtnDisabled:
        result.procedureFolder?.procedureSaveInCategoryStatusID === dataStatus.approval,
      isSavedInReturnBtnDisabled:
        result.procedureFolder?.procedureSaveInCategoryStatusID === dataStatus.return,
    };
  };

  handleManageShareTaskServerPathSectionStateState = (result: any) => {
    return {
      ...this.state.serverPathSectionState,
      serverPathValue: result.procedureFolder?.clientServerPath || null,
      isServerPathReturned: result.procedureFolder?.clientServerPathStatusID === dataStatus.return,
      serverPathReturnReasonInputValue:
        result.procedureFolder?.clientServerPathReturnReason || null,
      clientServerPathStatusID: result.procedureFolder?.clientServerPathStatusID || null,
      clientServerPathStatusName: result.procedureFolder?.clientServerPathStatusName || null,
      clientServerPath: result.procedureFolder?.clientServerPath || "",
      isServerPathApproveBtnDisabled:
        result.procedureFolder?.clientServerPathStatusID === dataStatus.approval,
      isServerPathReturnBtnDisabled:
        result.procedureFolder?.clientServerPathStatusID === dataStatus.return,
    };
  };

  setManageShareTaskSavedInServerPathState = (result: any) => {
    this.setState({
      savedInSectionState: this.handleManageShareTaskSavedInSectionState(result),
      serverPathSectionState: this.handleManageShareTaskServerPathSectionStateState(result),
    });
  };

  setManageShareTaskSavedInReturnReasonLog = (item: any, index: any) => {
    if (
      item.procedureSaveInCategoryStatusID === dataStatus.return &&
      item.actionID === actions.return
    ) {
      // @ts-ignore
      this.savedInReturnReasonLog.push({
        key: index,
        returnedBy: item.auditedByName,
        returnDate: this._formateDate(item.modifiedDate),
        returnReasonColumn: item.procedureSaveInCategoryReturnReason,
      });
    }
  };

  setManageShareTaskServerPathReturnReasonLog = (item: any, index: any) => {
    if (item.clientServerPathStatusID === dataStatus.return && item.actionID === actions.return) {
      // @ts-ignore
      this.serverPathReturnReasonLog.push({
        key: index,
        returnedBy: item.auditedByName,
        returnDate: this._formateDate(item.modifiedDate),
        returnReasonColumn: item.clientServerPathReturnReason,
      });
    }
  };

  setManageShareTaskSavedInAndServerPathReturnReasonLog = (list: any) => {
    list.sort((a: any, b: any) => {
      return b.modifiedDate.localeCompare(a.modifiedDate);
    });
    list.forEach((item: any, index: any) => {
      this.setManageShareTaskSavedInReturnReasonLog(item, index);
      this.setManageShareTaskServerPathReturnReasonLog(item, index);
    });
  };

  initManageShareTaskServerPathSectionState = (result: any) => {
    // @ts-ignore
    this.initServerPathSectionState = {
      // @ts-ignore
      ...this.initServerPathSectionState,
      ...this.buildManageShareTaskServerPathSectionState(result.procedureFolder),
    };
  };

  initManageShareTaskSavedInSectionState = (result: any) => {
    // @ts-ignore
    this.initSavedInSectionState = {
      // @ts-ignore
      ...this.initSavedInSectionState,
      ...this.buildManageShareTaskSavedInSectionState(result.procedureFolder),
    };
  };

  initManageShareTaskPrimitiveServerPathSectionState = (lastStepHistoryData: any) => {
    // @ts-ignore
    this.primitiveServerPathSectionState = {
      // @ts-ignore
      ...this.primitiveServerPathSectionState,
      ...this.buildManageShareTaskServerPathSectionState(lastStepHistoryData),
    };
  };

  initManageShareTaskPrimitiveSavedInSectionState = (lastStepHistoryData: any) => {
    // @ts-ignore
    this.primitiveSavedInSectionState = {
      // @ts-ignore
      ...this.primitiveSavedInSectionState,
      ...this.buildManageShareTaskSavedInSectionState(lastStepHistoryData),
    };
  };

  setInitManageShareTaskProcedureTableData = () => {
    // @ts-ignore
    this.procedureTableData.forEach((item: any) => {
      // @ts-ignore
      this.initProcedureTableData.push({
        data: JSON.parse(JSON.stringify(item.data)),
        checked: item.checked,
        isApproveDisabled: item.isApproveDisabled,
        isReturnDisabled: item.isReturnDisabled,
        isReturned: item.isReturned,
        isError: item.isError,
        replaceRef: item.replaceRef,
        attachmentEditIcon: reasonEditDefaultIcon,
        isDelete: false,
        isUpdate: false,
      });
    });
  };

  setManageShareTaskProcedureFileData = (result: any) => {
    if (result.procedureFolder !== null) {
      const historyList = result.procedureFolder?.stepHistoryList.sort((x: any, y: any) =>
        y.modifiedDate.localeCompare(x.modifiedDate)
      );

      this.initManageShareTaskServerPathSectionState(result);

      this.initManageShareTaskSavedInSectionState(result);

      if (historyList.length !== 0) {
        const lastStepHistoryData = historyList[0];
        this.initManageShareTaskPrimitiveServerPathSectionState(lastStepHistoryData);
        this.initManageShareTaskPrimitiveSavedInSectionState(lastStepHistoryData);
      }

      // @ts-ignore
      this.procedureFileStepID = result.procedureFolder.procedureFileStepID;
      this.setProcedureTableData(result.procedureFolder);
      this.setInitManageShareTaskProcedureTableData();

      this.setState({
        // @ts-ignore
        fileTableData: this.procedureTableData,
        jbProcedureSavedIn: result.procedureFolder.jbProcedureSaveIn,
      });

      this.setManageShareTaskSavedInAndServerPathReturnReasonLog(
        result.procedureFolder.stepHistoryList
      );
      this.setManageShareTaskSavedInServerPathState(result);
    }
  };

  setProcedureFileData = (result: any) => {
    this.setManageShareTaskProcedureFileData(result);
  };

  buildManageShareTaskSavedInSectionState = (data: any) => {
    return {
      savedInReturnReasonInputValue: data.procedureSaveInCategoryReturnReason,
      savedInRadioValue: data.procedureSaveInCategoryID,
      isSavedInReturned: data.procedureSaveInCategoryStatusID === dataStatus.return,
      procedureSaveInCategoryStatusID: data.procedureSaveInCategoryStatusID,
      isSavedInApproveBtnDisabled: data.procedureSaveInCategoryStatusID === dataStatus.approval,
      isSavedInReturnBtnDisabled: data.procedureSaveInCategoryStatusID === dataStatus.return,
    };
  };

  /**
   * Build ServerPath Section Data From ProcedureFolder
   * @param {*} data
   * @param {*} isRevise
   * @returns
   */
  buildManageShareTaskServerPathSectionState = (data: any) => {
    return {
      // @ts-ignore
      ...this.primitiveServerPathSectionState,
      serverPathValue: data.clientServerPath,
      isServerPathReturned: data.clientServerPathStatusID === dataStatus.return,
      serverPathReturnReasonInputValue: data.clientServerPathReturnReason,
      clientServerPathStatusID: data.clientServerPathStatusID,
      clientServerPathStatusName: data.clientServerPathStatusName,
      clientServerPath: data.clientServerPath,
      isServerPathApproveBtnDisabled: data.clientServerPathStatusID === dataStatus.approval,
      isServerPathReturnBtnDisabled: data.clientServerPathStatusID === dataStatus.return,
    };
  };

  _getFlowDataSuccess = (result: any) => {
    const { procedureStepStatus } = result;

    StepService.setStepInterfaceMergePayload(result, {
      isHistorical: procedureStepStatus === "Complete",
      isShareTaskProcess: true,
      // @ts-ignore
      procedureStepId: this.procedureStepID,
      // @ts-ignore
      procedureTaskId: this.taskID,
    });

    this.getInitData(
      ApproveShareService.getManageShareTaskStepItem,
      "Get Shared Tasks Failed",
      undefined,
      result,
      StepService.getMergePayloadBySettingKey([
        CompleteStepBusinessType.taskInfo.settingKey,
        CompleteStepBusinessType.shareTask.settingKey,
      ])
    );
  };

  _getFlowDataFailed = () => {
    this._alertError("Get Shared Tasks Failed");
  };

  getFlowData = () => {
    const parentPageData = this._getRoutingParam("ParentPage");
    const param = {
      // @ts-ignore
      taskID: this.taskID,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      parentPage: parentPageData,
    };
    ApproveShareService.getFlowStepData(param, this._getFlowDataSuccess, this._getFlowDataFailed);
  };

  componentDidMount() {
    this.getFlowData();
  }

  /* function about get data from procedure file table */
  manageShareTaskReturnFileDataValue = (name: any, index: any) => {
    // @ts-ignore
    const procedureFileData = procedureRef.current.getDataList();
    // @ts-ignore
    let deleteList = procedureRef.current.getDeleteList();
    let combineDatalist = procedureFileData.concat(deleteList);
    return combineDatalist[index].data.find((item: any) => item.name === name);
  };

  setManageShareTaskServerPathObj = () => {
    let serverPathValue = null;
    let serverPathStatus = null;
    let serverPathReturnReasonInputValue = null;

    if (procedureServerPathRef.current !== null) {
      const serverPathState =
        // @ts-ignore
        procedureServerPathRef.current.state.serverPathSectionState;
      serverPathValue = serverPathState.serverPathValue;
      serverPathStatus = serverPathState.serverPathStatus;
      serverPathReturnReasonInputValue = serverPathState.serverPathReturnReasonInputValue;
    }

    return {
      serverPathValue: serverPathValue,
      serverPathStatus: serverPathStatus,
      serverPathReturnReasonInputValue: serverPathReturnReasonInputValue,
    };
  };

  manageShareTaskSubmitDataPara = (fileDtos: any, actionID: any, actionName: any) => {
    const serverPathObj = this.setManageShareTaskServerPathObj();

    const {
      savedInRadioValue,
      procedureSaveInCategoryStatusID,
      savedInReturnReasonInputValue,
      // @ts-ignore
    } = procedureSavedInRef.current.state.savedInSectionState;
    return {
      // @ts-ignore
      isInitial: this.isRevisePage,
      clientServerPath: serverPathObj.serverPathValue,
      clientServerPathStatusID: serverPathObj.serverPathStatus,
      clientServerPathReturnReason: serverPathObj.serverPathReturnReasonInputValue,
      // @ts-ignore
      procedureId: this.procedureId,
      // @ts-ignore
      workflowProcessInstanceId: this.workflowProcessInstanceId,
      // @ts-ignore
      flowCategoryID: this.flowCategoryID,
      procedureFiles: fileDtos,
      // @ts-ignore
      procedureFileStepID: this.procedureFileStepID,
      rejectReason:
        approvePageRef.current === null
          ? null
          : // @ts-ignore
            approvePageRef.current.state.pageState.rejectReason,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      procedureSaveInCategoryID: savedInRadioValue,
      procedureSaveInCategoryStatusID: procedureSaveInCategoryStatusID,
      procedureSaveInCategoryReturnReason: savedInReturnReasonInputValue,
      actionName: actionName,
      actionID: actionID,
      accountID: null,
    };
  };

  /* function about return submit data to use in integrate trigger api */
  manageShareTaskhandleReturnSubmitData = (actionID: any, actionName: any) => {
    const fileDtos: any[] = [];
    if (procedureRef.current !== null) {
      // @ts-ignore
      const procedureFileData = procedureRef.current.getDataList();
      // @ts-ignore
      let deleteList = procedureRef.current.getDeleteList();
      let combineDatalist = procedureFileData.concat(deleteList);
      combineDatalist.forEach((item: any, index: any) =>
        fileDtos.push({
          fileID:
            this.manageShareTaskReturnFileDataValue("newVersion", index).fileId === null
              ? this.manageShareTaskReturnFileDataValue("fileId", index).value
              : this.manageShareTaskReturnFileDataValue("newVersion", index).fileId,
          createdDate: this.manageShareTaskReturnFileDataValue("uploadedDate", index).value,
          uploadBy: this.manageShareTaskReturnFileDataValue("uploadById", index).value,
          uploadByName: this.manageShareTaskReturnFileDataValue("uploadByName", index).value,
          fileName:
            this.manageShareTaskReturnFileDataValue("newVersion", index).value === null
              ? this.manageShareTaskReturnFileDataValue("fileName", index).value
              : this.manageShareTaskReturnFileDataValue("newVersion", index).value,
          fileKey: this.manageShareTaskReturnFileDataValue("fileKey", index).value,
          dataStatusID: this.manageShareTaskReturnFileDataValue("status", index).value,
          attachmentFileID: this.manageShareTaskReturnFileDataValue("attachment", index).fileId,
          attachmentName: this.manageShareTaskReturnFileDataValue("attachment", index).value,
          returnReason: this.manageShareTaskReturnFileDataValue("returnReason", index).value,
          fileTagID: this.manageShareTaskReturnFileDataValue("fileName", index).tagValue,
          procedureFileStepID: this.manageShareTaskReturnFileDataValue("procedureFileStepID", index)
            .value,
          procedureFileID: this.manageShareTaskReturnFileDataValue("procedureFileID", index).value,
          note: this.manageShareTaskReturnFileDataValue("note", index).value,
          oldFileID:
            this.manageShareTaskReturnFileDataValue("newVersion", index).fileId === null
              ? null
              : this.manageShareTaskReturnFileDataValue("fileId", index).value,
          oldFileName:
            this.manageShareTaskReturnFileDataValue("newVersion", index).value === null
              ? null
              : this.manageShareTaskReturnFileDataValue("fileName", index).value,
          isDelete: item.isDelete,
          isUpdate: item.isUpdate,
        })
      );
    }

    return this.manageShareTaskSubmitDataPara(fileDtos, actionID, actionName);
  };

  setSupportingFileData = (result: any) => {
    this.setSupportingTableData(result);
    this.setState({
      // @ts-ignore
      supportingTableData: this.supportingTableData,
    });
  };

  setManageShareTaskPageType = () => {
    this.setSharePageType();
  };

  handleManageShareTaskPageProps = () => {
    const {
      receiveDate,
      requestByName,
      procedureStepStatus,
      procedureStatus,
      rejectStatus,
      currentRole,
      rejectReason,
    } = this.state.pageState;

    return {
      receiveDate,
      requestByName,
      procedureStepStatus,
      procedureStatus,
      rejectStatus,
      currentRole,
      procedureReplaceFileRef,
      rejectReason,
      // @ts-ignore
      actionID: this.actionID,
    };
  };

  handleManageShareTaskSectionProps = () => {
    const { taskInfoData, procedureInfoData } = this.state;

    return {
      taskInfoData,
      procedureInfoData,
      ppoList: this.state.ppoList,
    };
  };

  handleManageShareTaskSavedInProps = () => {
    const {
      savedInReturnReasonInputValue,
      savedInReturnReasonValue,
      savedInReasonStatus,
      procedureSaveInCategoryStatusID,
      savedInRadioValue,
    } = this.state.savedInSectionState;

    return {
      savedInReturnReasonInputValue,
      savedInReturnReasonValue,
      savedInReasonStatus,
      procedureSaveInCategoryStatusID,
      savedInRadioValue,
      initSavedInStatus:
        // @ts-ignore
        this.initSavedInSectionState.procedureSaveInCategoryStatusID,
      // @ts-ignore
      savedInReturnReasonLog: this.savedInReturnReasonLog,
    };
  };

  handleManageShareTaskServerPathProps = () => {
    const {
      clientServerPathStatusName,
      serverPathReturnReasonValue,
      serverPathReasonStatus,
      serverPathReturnReasonInputValue,
      clientServerPathStatusID,
      serverPathValue,
    } = this.state.serverPathSectionState;

    return {
      clientServerPathStatusName,
      serverPathReturnReasonValue,
      serverPathReasonStatus,
      serverPathReturnReasonInputValue,
      // @ts-ignore
      serverPathReturnReasonLog: this.serverPathReturnReasonLog,
      clientServerPathStatusID,
      serverPathValue,
    };
  };

  handleManageShareTaskServerParams = () => {
    return {
      // @ts-ignore
      ProcedureTaskId: this.taskID,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
      // @ts-ignore
      ProcedureFileStepID: this.procedureFileStepID,
      // @ts-ignore
      WorkflowProcessInstanceId: this.workflowProcessInstanceId,
      // @ts-ignore
      FlowCategoryID: this.flowCategoryID,
    };
  };

  handleManageShareTaskRevisePendingPage = (procedureTableData: any) => {
    const { shareTaskData, jbProcedureSavedIn } = this.state;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    return (
      // @ts-ignore
      <ReviseShareTaskProcess
        pageProps={this.handleManageShareTaskPageProps()}
        sectionProps={this.handleManageShareTaskSectionProps()}
        savedInProps={this.handleManageShareTaskSavedInProps()}
        serverPathProps={this.handleManageShareTaskServerPathProps()}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        shareTaskData={shareTaskData}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        data={procedureTableData}
        supportingTableData={this.state.supportingTableData}
        params={this.handleManageShareTaskServerParams()}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        primitiveSavedInSectionState={(this as any).primitiveSavedInSectionState}
        primitiveServerPathSectionState={(this as any).primitiveServerPathSectionState}
        updateProcedureFileNum={this.updateProcedureFileNum}
        fileTableData={procedureTableData}
        jbProcedureSavedIn={jbProcedureSavedIn}
        returnFileDataValue={this.manageShareTaskReturnFileDataValue}
        handleReturnSubmitData={this.manageShareTaskhandleReturnSubmitData}
        closePage={this.closePage}
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  handleManageShareTaskReviseCompletePage = (procedureTableData: any) => {
    const { taskInfoData, procedureInfoData, shareTaskData, jbProcedureSavedIn } = this.state;

    const { receiveDate, requestByName, procedureStatus, rejectStatus, rejectReason } =
      this.state.pageState;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    return (
      <ReviseShareTaskComplete
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        fileTableData={procedureTableData}
        supportingTableData={this.state.supportingTableData}
        pageProps={{
          receiveDate,
          requestByName,
          procedureStatus,
          rejectReason,
          rejectStatus,
          // @ts-ignore
          actionID: this.actionID,
        }}
        sectionProps={{
          taskInfoData,
          procedureInfoData,
          ppoList: this.state.ppoList,
        }}
        shareTaskData={shareTaskData}
        jbProcedureSavedIn={jbProcedureSavedIn}
        params={this.handleManageShareTaskServerParams()}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  handleManageShareTaskApprovePendingPage = (procedureTableData: any) => {
    const { shareTaskData, jbProcedureSavedIn } = this.state;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    return (
      // @ts-ignore
      <ApproveShareTaskProcess
        ref={approvePageRef}
        pageProps={this.handleManageShareTaskPageProps()}
        sectionProps={this.handleManageShareTaskSectionProps()}
        savedInProps={this.handleManageShareTaskSavedInProps()}
        serverPathProps={this.handleManageShareTaskServerPathProps()}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        data={procedureTableData}
        supportingTableData={this.state.supportingTableData}
        params={this.handleManageShareTaskServerParams()}
        closePage={this.closePage}
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        shareTaskData={shareTaskData}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        updateProcedureFileNum={this.updateProcedureFileNum}
        returnFileDataValue={this.manageShareTaskReturnFileDataValue}
        handleReturnSubmitData={this.manageShareTaskhandleReturnSubmitData}
        fileTableData={procedureTableData}
        jbProcedureSavedIn={jbProcedureSavedIn}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  handleManageShareTaskApproveCompletePage = (procedureTableData: any) => {
    const { taskInfoData, procedureInfoData, shareTaskData, jbProcedureSavedIn } = this.state;

    const { receiveDate, requestByName, procedureStatus, rejectStatus, rejectReason } =
      this.state.pageState;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    return (
      <ApproveShareTaskComplete
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        fileTableData={procedureTableData}
        supportingTableData={this.state.supportingTableData}
        pageProps={{
          receiveDate,
          requestByName,
          procedureStatus,
          rejectReason,
          rejectStatus,
          // @ts-ignore
          actionID: this.actionID,
        }}
        sectionProps={{
          taskInfoData,
          procedureInfoData,
          ppoList: this.state.ppoList,
        }}
        shareTaskData={shareTaskData}
        jbProcedureSavedIn={jbProcedureSavedIn}
        params={this.handleManageShareTaskServerParams()}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  handleManageShareTaskSubmitCompletePage = (procedureTableData: any) => {
    const { taskInfoData, procedureInfoData, shareTaskData, jbProcedureSavedIn } = this.state;

    const { receiveDate, requestByName, procedureStatus, rejectStatus, rejectReason } =
      this.state.pageState;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    return (
      <SubmitShareTaskComplete
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        fileTableData={procedureTableData}
        supportingTableData={this.state.supportingTableData}
        pageProps={{
          receiveDate,
          requestByName,
          procedureStatus,
          rejectReason,
          rejectStatus,
          // @ts-ignore
          actionID: this.actionID,
        }}
        sectionProps={{
          taskInfoData,
          procedureInfoData,
          ppoList: this.state.ppoList,
        }}
        shareTaskData={shareTaskData}
        jbProcedureSavedIn={jbProcedureSavedIn}
        params={this.handleManageShareTaskServerParams()}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  setManageShareTaskProcedureTableData = () => {
    return JSON.parse(JSON.stringify(this.state.fileTableData));
  };

  render() {
    const { loading, procedureFileNum, uploadProcedureFileNum } = this.state.pageState;

    const procedureTableData = this.setManageShareTaskProcedureTableData();

    this.setManageShareTaskPageType();

    return (
      <NormalSpin
        spinning={loading}
        size="large"
        indicator={
          procedureFileNum > 0 ? (
            <p className={styles.loadingText}>
              Uploading {uploadProcedureFileNum}/{procedureFileNum} file
            </p>
          ) : undefined
        }
        children={
          <>
            {/* @ts-ignore */}
            {this.isRevisePendingPage &&
              this.handleManageShareTaskRevisePendingPage(procedureTableData)}
            {/* @ts-ignore */}
            {this.isReviseCompletePage &&
              this.handleManageShareTaskReviseCompletePage(procedureTableData)}
            {/* @ts-ignore */}
            {this.isApprovePendingPage &&
              this.handleManageShareTaskApprovePendingPage(procedureTableData)}
            {/* @ts-ignore */}
            {this.isApproveCompletePage &&
              this.handleManageShareTaskApproveCompletePage(procedureTableData)}
            {/* @ts-ignore */}
            {this.isSubmitCompletePage &&
              this.handleManageShareTaskSubmitCompletePage(procedureTableData)}
          </>
        }
      />
    );
  }
}
